/*
  ONE Stripe INSTANCE FOR THE WHOLE APP.

  App.js imports PaymentForm, PaymentFormUs and ConfirmationPage at module
  scope, and each of them called loadStripe() on its own with the same
  publishable key. So every page load built three Stripe instances before any
  payment code ran, whichever route was being shown. Stripe's guidance is one
  per page, and the wallet buttons are the most fragile thing on this page.

  Everything imports from here instead.
*/
import { loadStripe } from "@stripe/stripe-js";

export const STRIPE_PK = "pk_live_DcCw5bq0Njn1uwNSuvv3RlOW";

export const stripePromise = loadStripe(STRIPE_PK);
